import React, { useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { setPosition } from "../../store/Subtitle/subTitleSlice";
import { getTileImage } from "../../utils";

const SubTitleAlignPopover = () => {
  const dispatch = useDispatch();
  const onDDClick = () => {};
  const slideMenu = useMemo(
    () => [
      {
        title: "Top",
        onClick: onDDClick,
        icon: "/tool/dashboard/static/images/icons/subtitle/top.svg",
        value: "top",
      },
      {
        title: "Center",
        onClick: onDDClick,
        icon: "/tool/dashboard/static/images/icons/subtitle/middle.svg",
        value: "center",
      },
      {
        title: "Bottom",
        onClick: onDDClick,
        icon: "/tool/dashboard/static/images/icons/subtitle/end.svg",
        value: "bottom",
      },
    ],
    []
  );
  const { position = "" } = useSelector((state) => state.subTitle);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(
    slideMenu.findIndex((ele) => ele.value === position)
  );

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  const subTitlePosition = () => {
    switch (selected) {
      case 0:
        return "top-4";
      case 1:
        return "top-[100px]";
      default:
        return "bottom-3";
    }
  };
  const { selectedVideo } = useSelector((state) => state.subTitle);

  return (
    <div className="w-full">
      <div className="flex items-center pl-[25px]  h-[56px] font-medium bg-gradient-sidebar">
        Subtitle Alignment
      </div>
      <div className="pl-[26px] pr-4">
        <div className="pt-[66px] flex gap-6">
          <div className="h-[218px] w-[374px] relative">
            {!!selectedVideo?.thumbnail && (
              <video
                src={getTileImage({
                  ...selectedVideo,
                  thumbnail: selectedVideo.filePath || selectedVideo.thumbnail,
                })}
                className="w-full h-full"
              />
            )}
            {!!selectedVideo?.thumbnail && (
              <div
                className={`absolute text-white ${subTitlePosition()} right-6 w-fit`}
              >
                This is your new subtitles and you can edit it
              </div>
            )}
          </div>
          <div>
            <p className="font-medium text-sm text-[#11142DB2] max-w-[256px] pb-4">
              Choose alignment for the subtitles to be displayed
            </p>
            <div className="relative inline-block text-left">
              <div>
                <div
                  type="button"
                  className="cursor-pointer flex items-center justify-between w-[200px] px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  onClick={toggleDropdown}
                >
                  <span>{slideMenu[selected].title}</span>
                  <img
                    src={
                      "/tool/dashboard/static/images/icons/subtitle/arrow-down-icon.svg"
                    }
                    className={`${isOpen && "rotate-180"}`}
                  />
                </div>
              </div>
              {isOpen && (
                <div className="absolute w-[200px] cursor-pointer right-0 z-10  mt-2 origin-top-right bg-white border border-gray-300 divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none">
                  <div className="py-1">
                    {slideMenu.map((rest, index) => {
                      return (
                        <div
                          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          onClick={() => {
                            dispatch(setPosition(rest.value));
                            handleSelect(index);
                          }}
                        >
                          <img src={rest.icon} className="w-5 h-5 mr-[10px]" />
                          <span className="text-[#11142DB2] text-sm font-semibold">
                            {rest.title}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex gap-1 items-center my-2 h-[20px]">
          <img
            src={"/tool/dashboard/static/images/icons/subtitle/alert-circle.svg"}
          />
          <span className="font-semibold text-[#11142D80] text-xs">
            Please Note: The style will be applied to all slides
          </span>
        </div>
      </div>
    </div>
  );
};

export default SubTitleAlignPopover;
